import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    launchAdjustmentJob as launchAdjustmentJobApi,
    getAdjustmentJobStatus as getAdjustmentJobStatusApi,
    stopAdjustmentJob as stopAdjustmentJobApi,
    restartAdjustmentJob as restartAdjustmentJobApi,
    getAllAdjustmentJobs as getAllAdjustmentJobsApi,
} from '../../helpers';
import {
    adjustmentJobsApiResponseSuccess,
    adjustmentJobsApiResponseError,
} from './actions';
import { AdjustmentJobsActionTypes } from './constants';
import { addToast } from '../actions';
import { adjustmentJobResponseToAdjustmentJobObject } from '../../helpers/mappers/adjustment-job';

export function* launchAdjustmentJob({ payload: { integrationId } }) {
    try {
        yield put(addToast({ desc: 'Starting adjustment job', type: 'success' }));
        const launchAdjustmentJobResponse = yield call(launchAdjustmentJobApi, integrationId);
        yield put(addToast({ desc: 'Adjustment job completed', type: 'success' }));
        yield put(adjustmentJobsApiResponseSuccess(AdjustmentJobsActionTypes.LAUNCH_ADJUSTMENT_JOB, null));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(adjustmentJobsApiResponseError(AdjustmentJobsActionTypes.LAUNCH_ADJUSTMENT_JOB, error));
    }
}

export function* getAdjustmentJobStatus({ payload: { integrationId } }) {
    try {
        const adjustmentJobStatus = yield call(getAdjustmentJobStatusApi, integrationId);
        yield put(adjustmentJobsApiResponseSuccess(AdjustmentJobsActionTypes.GET_ADJUSTMENT_JOB_STATUS, adjustmentJobStatus));
    } catch (error) {
        yield put(adjustmentJobsApiResponseError(AdjustmentJobsActionTypes.GET_ADJUSTMENT_JOB_STATUS, error));
    }
}

export function* stopAdjustmentJob({ payload: { integrationId } }) {
    try {
        const stopAdjustmentJobResponse = yield call(stopAdjustmentJobApi, integrationId);
        yield put(adjustmentJobsApiResponseSuccess(AdjustmentJobsActionTypes.STOP_ADJUSTMENT_JOB, null));
    } catch (error) {
        yield put(adjustmentJobsApiResponseError(AdjustmentJobsActionTypes.STOP_ADJUSTMENT_JOB, error));
    }
}

export function* restartAdjustmentJob({ payload: { integrationId } }) {
    try {
        const restartAdjustmentJobResponse = yield call(restartAdjustmentJobApi, integrationId);
        yield put(adjustmentJobsApiResponseSuccess(AdjustmentJobsActionTypes.RESTART_ADJUSTMENT_JOB, null));
    } catch (error) {
        yield put(adjustmentJobsApiResponseError(AdjustmentJobsActionTypes.RESTART_ADJUSTMENT_JOB, error));
    }
}

export function* getAllAdjustmentJobs() {
    try {
        const getAllAdjustmentJobsResponse = yield call(getAllAdjustmentJobsApi);
        const adjustmentJobs = getAllAdjustmentJobsResponse.data.map((adjustmentJob) => 
            adjustmentJobResponseToAdjustmentJobObject(adjustmentJob)
        );
        yield put(adjustmentJobsApiResponseSuccess(AdjustmentJobsActionTypes.GET_ALL_ADJUSTMENT_JOBS, adjustmentJobs));
    } catch (error) {
        yield put(adjustmentJobsApiResponseError(AdjustmentJobsActionTypes.GET_ALL_ADJUSTMENT_JOBS, error));
    }
}

export function* watchLaunchAdjustmentJobSaga() {
    yield takeLatest(AdjustmentJobsActionTypes.LAUNCH_ADJUSTMENT_JOB, launchAdjustmentJob);
}

export function* watchGetAdjustmentJobStatusSaga() {
    yield takeLatest(AdjustmentJobsActionTypes.GET_ADJUSTMENT_JOB_STATUS, getAdjustmentJobStatus);
}

export function* watchStopAdjustmentJobSaga() {
    yield takeLatest(AdjustmentJobsActionTypes.STOP_ADJUSTMENT_JOB, stopAdjustmentJob);
}

export function* watchRestartAdjustmentJobSaga() {
    yield takeLatest(AdjustmentJobsActionTypes.RESTART_ADJUSTMENT_JOB, restartAdjustmentJob);
}

export function* watchGetAllAdjustmentJobsSaga() {
    yield takeLatest(AdjustmentJobsActionTypes.GET_ALL_ADJUSTMENT_JOBS, getAllAdjustmentJobs);
}

function* adjustmentJobsSaga() {
    yield all([
        fork(watchLaunchAdjustmentJobSaga),
        fork(watchGetAdjustmentJobStatusSaga),
        fork(watchStopAdjustmentJobSaga),
        fork(watchRestartAdjustmentJobSaga),
        fork(watchGetAllAdjustmentJobsSaga),
    ]);
}

export default adjustmentJobsSaga;
